module.exports = __webpack_public_path__ + "img/postback-step-6.en.e7791689.jpg";